import styled from 'styled-components'

const StyledPageLink = styled.div``

export default StyledPageLink
